import React from "react";
import { Comment, Upload, Icon, Form, Button, Input } from "antd";
// import moment from "moment";

const { TextArea } = Input;

const EditorForm = ({ onChange, onSubmit, submitting, msg, uploadProps }) => (
  <div>
    <Form.Item>
      <TextArea rows={4} onChange={onChange} value={msg} />
    </Form.Item>
    <Form.Item>
      <Upload.Dragger {...uploadProps}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">
          Click or drag an audio or image file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading
          company data or other band files
        </p>
      </Upload.Dragger>
    </Form.Item>
    <Form.Item>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          htmlType="submit"
          loading={submitting}
          onClick={onSubmit}
          type="primary"
        >
          Add Message
        </Button>
      </div>
    </Form.Item>
  </div>
);

class Editor extends React.Component {
  state = {
    msg: "",
    fileList: [],
  };

  componentDidUpdate(prevProps, prevState) {
    console.log("prevprops", prevProps.resetEditor);
    console.log("current", this.props.resetEditor);
    if (
      prevProps.resetEditor !== this.props.resetEditor &&
      this.props.resetEditor
    ) {
      this.setState({ msg: "", fileList: [] });
      this.props.onResetEditorDone();
    }
  }

  handleSubmit = () => {
    const { msg, fileList } = this.state;
    const { commentId } = this.props;

    if (!msg) {
      return;
    }

    const commentData = {
      msg: msg,
      fileList,
      commentId: commentId,
    };

    this.props.onAddComment(commentData);
  };

  handleChange = (e) => {
    this.setState({
      msg: e.target.value,
    });
  };

  render() {
    const { msg, fileList } = this.state;
    const { submitting } = this.props;

    console.log("resetEditor", this.props.resetEditor);

    const uploadProps = {
      multiple: true,
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };

    return (
      <div className="comment-editor">
        <Comment
          content={
            <EditorForm
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              submitting={submitting}
              uploadProps={uploadProps}
              msg={msg}
            />
          }
        />
      </div>
    );
  }
}

export default Editor;
